/**
 * Gets a value from a nested object using dot-notation path.
 * Example: getNestedValue(data, "contractor.person.firstName")
 */
export function getNestedValue(obj: Record<string, any>, path: string): any {
  return path.split('.').reduce(
    (current, key) => (current !== undefined && current !== null ? current[key] : undefined),
    obj
  );
}

/**
 * Sets a value in a nested object using dot-notation path.
 * Returns a new object (immutable update).
 * Example: setNestedValue(data, "contractor.person.firstName", "John")
 */
export function setNestedValue(
  obj: Record<string, any>,
  path: string,
  value: any
): Record<string, any> {
  const keys = path.split('.');
  const result = { ...obj };

  let current: Record<string, any> = result;
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    current[key] = { ...current[key] };
    current = current[key];
  }

  current[keys[keys.length - 1]] = value;
  return result;
}